import { MAX_NAME_CHARS } from '../../game/constants/world';

export function sanitizeJoinName(name: string): string {
  return name.trim().slice(0, MAX_NAME_CHARS);
}
